<template>
  <div class="comWrap">
    <div class="comItemWrap" v-for="(item,index) in list" :key="index">
      <div class="comItemTiitle">{{item.title}}</div>
      <div class="comItemContent" v-html="item.content"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
    data() {
      return {
        info: "",
        list:[
          {
            title:"指标因子",
            content:"温室气体指标因子：CO₂、CH₄、H2O、N2O、CO、H2、 NH3等<br>" +
              "气象类型：微气象五参(风速、风向、温度、湿度、气压)"
          },
          {
            title:"应用场景",
            content:"固定式、车载式、便携式手提箱、无人机机载"
          },
          {
            title:"方案内容",
            content:"建设基于多种感知技术、覆盖多种应用场景、多项数据融合，实时交互分析研判的温室气体在线监测网络。<br>" +
              "实现秒级数据和米级范围监测采集，智能化数据分析 + 多证据耦合分析研判，精准判断温室气体排放特性。"
          }
        ]
      }
    },
    created() {
    },
    components: {},
    methods: {}
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "~@/common/stylus/mixin.styl"
  .comWrap
    .comItemWrap
      margin-bottom 30px
      .comItemTiitle
        font-size 20px
        font-weight bold
        padding 15px 30px
        background-color #3E85F1
        border-radius 10px
        border 1px solid #072655
        display inline-block
        color white
      .comItemContent
        font-size 16px
        line-height 30px
        color #333
        margin-top 20px
</style>



// WEBPACK FOOTER //
// src/views/solution/components/com4.vue